<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <ReligionTable />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import ReligionTable from "./components/ReligionTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    ReligionTable,
    // ProjectsTable,
  },
};
</script>
